var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.993 12c.517 0 .942.383 1 .883L14 13c0 .552-.45 1-1.007 1H1.007C.45 14 0 13.556 0 13c0-.552.45-1 1.007-1h11.986zm0-6c.517 0 .942.383 1 .883L14 7c0 .552-.45 1-1.007 1H1.007C.45 8 0 7.556 0 7c0-.552.45-1 1.007-1h11.986zm0-6c.517 0 .942.383 1 .883L14 1c0 .552-.45 1-1.007 1H1.007C.45 2 0 1.556 0 1c0-.552.45-1 1.007-1h11.986z",
    transform: "translate(7 7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.fe9407503ae6810de30cef163b89eb85.svg";
export { ForwardRef as ReactComponent };